import { render, staticRenderFns } from "./UnterrichtDashboardLink.vue?vue&type=template&id=b0c07952&scoped=true"
import script from "./UnterrichtDashboardLink.vue?vue&type=script&lang=ts"
export * from "./UnterrichtDashboardLink.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtDashboardLink.vue?vue&type=style&index=0&id=b0c07952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c07952",
  null
  
)

export default component.exports